import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportDetailedNotesFilters, getReportDetailedNotesAction } from "redux/actions/Reports/reportDetailedNotes/reportDetailedNotesActions";
import { useSearch } from "hooks/useSearch";

export const ReportDetailedNotesView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportDetailedNotes);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportDetailedNotesAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Detallado de Notas" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingDetailedNotes
        ? <LoadingComponent />
        : <TableInputs
            reducer="reportDetailedNotes"
            dates
            stations
            maxDate={newDate()}
            dispatchAction={setReportDetailedNotesFilters}
            submitAction={handleSubmit}
            submitSecond={(e) => handleSubmit(e, false)}
            submitButtonName="PDF"
          />
      }
    </GlobalBox>
  );
};
